import { inject, injectable } from 'inversify';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import type { JwtRepositoryInterface } from '@shared/common/network/domain/repository/jwt.repository';

interface GetTokenOptions {
  forceRefresh?: boolean;
}

@injectable()
export class JwtService {
  public constructor(
    @inject(NetworkDependencyTypes.JwtRepository) private readonly jwtRepository: JwtRepositoryInterface,
  ) {}

  public async getActiveEncodedJwt(options: GetTokenOptions = {}): Promise<string> {
    return this.jwtRepository.getToken(options);
  }

  public clearActiveJwt(): void {
    this.jwtRepository.clearToken();
  }
}
